export const UNSCHEDULED_ITEMS_JQL = "duedate IS NULL AND StatusCategory != 'Complete'";
export const CALENDAR_ITEM_FIELDS = [
	'assignee',
	'duedate',
	'issuekey',
	'issuetype',
	'priority',
	'startdate',
	'status',
	'summary',
];
export const CALENDAR_ITEM_PAGE_SIZE = 100;
